import U from '../js/utils';

// Module for the suggestion dropdown
export default async ({elID, ddData, valueDataName, textDataName, requiredYN, onselect, className, initValue}) => {
  return new Promise(async (resolve, reject) => {
    try {
      // First create the options HTML
      const suggestionsList = await U.buildListDD({
        data: ddData,
        value: valueDataName,
        text: textDataName,
        className,
        initValue,
      });

      // Create the container div
      const div = `
        <div id="${elID}Container" class="suggestion-dropdown-container">
          <ul id="${elID}"
            class="suggestion-list" 
            name="${elID}" 
            val="select"
            ${requiredYN ? 'required' : ''}
          >
            ${suggestionsList}
          </ul>
        </div>
      `;

      // Create the DOM element
      const element = U.createHTMLElementFromString(div);

      // Add event listeners to all option elements
      const options = element.querySelector('.suggestion-list');
      options.addEventListener('click', (e) => {
        // Reference value of data-set attribute of selected suggestion item
        if (e.currentTarget.id === 'orgListDropdown') {
          thsPage.vars.organisation = e.target.getAttribute('data-value');
          thsPage.vars.organisation_text = e.target.textContent; // Store the text
        }
        if (e.currentTarget.id === 'orgBranchListDropdown') {
          thsPage.vars.organisation_branch = e.target.getAttribute('data-value');
          thsPage.vars.organisation_branch_text = e.target.textContent; // Store the text
        }
        if (e.currentTarget.id === 'advisorListDropdown') {
          thsPage.vars.advisor = e.target.getAttribute('data-value');
          thsPage.vars.advisor_text = e.target.textContent; // Store the text
        }
        if (e.currentTarget.id === 'targetAdvisorListDropdown') {
          thsPage.vars.target_advisor = e.target.getAttribute('data-value');
          thsPage.vars.target_advisor_text = e.target.textContent;
        }
        if (e.currentTarget.id === 'overviewTargetAdvisorListDropdown') {
          thsPage.vars.overview_target_advisor = e.target.getAttribute('data-value');
          thsPage.vars.overview_target_advisor_text = e.target.textContent;
        }

        const host =
          (window.thsPage && typeof window.thsPage[onselect] === 'function' && window.thsPage) ||
          (window.thsTab && typeof window.thsTab[onselect] === 'function' && window.thsTab) ||
          (window.thsSubTab && typeof window.thsSubTab[onselect] === 'function' && window.thsSubTab);
        if (host) host[onselect]();
      });
      resolve(element);
    } catch (error) {
      reject(error);
    }
  });
};
